import React, { useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  useMediaQuery,
  Grid,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { Formik, Field } from "formik";
import * as Yup from "yup";
import { useTheme } from "@mui/material/styles";
import { InputText, setTitleCase } from "../../../components/template/partials";
import { useAccountUIContext } from "../AccountUIContext";
import { editUser } from "../../../../utils/action";

// inital values form
const initialValues = (autoComplate) => {
  return {
    fullname: autoComplate?.nama_lengkap ?? "",
    email: autoComplate?.email ?? "",
    description: autoComplate?.keterangan ?? "",
  };
};

// form field validation schema
const validationSchema = Yup.object().shape({
  fullname: Yup.string().required("Nama Lengkap wajib diisi!"),
  email: Yup.string()
    .email("Format Email tidak sesuai")
    .required("Email wajib diisi!"),
  description: Yup.string().required("Keterangan wajib diisi!"),
});

export function AccountProfileEdit() {
  const accountUIContext = useAccountUIContext();
  const accountUIProps = useMemo(() => {
    return {
      data: accountUIContext.data,
      authData: accountUIContext.authData,
      saveUserData: accountUIContext.saveUserData,
      onHide: accountUIContext.onHide,
    };
  }, [accountUIContext]);
  const { data, authData, saveUserData, onHide } = accountUIProps;
  const [isLoading, setLoading] = useState(false);
  const theme = useTheme();
  const location = useLocation();
  const showDialog = location.state?.showDialog ?? false;
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  const handleFormSubmit = async (values) => {
    setLoading(true);
    const request = {
      nama_lengkap: values.fullname,
      email: values.email,
      keterangan: values.description,
    };
    // send to backend
    try {
      const response = await editUser(authData?.username, request);
      await saveUserData(response);
      toast.success(setTitleCase("berhasil update profile"));
    } catch (error) {
      toast.error(setTitleCase(error.response.data?.message));
    }
    setLoading(false);
    onHide();
  };

  return (
    <Dialog
      fullScreen={fullScreen}
      open={showDialog}
      onClose={onHide}
      aria-labelledby="responsive-dialog-account-profile-edit-title"
    >
      <DialogTitle id="responsive-dialog-account-profile-edit-title">
        Edit Profil
      </DialogTitle>
      <Formik
        enableReinitialize
        onSubmit={handleFormSubmit}
        initialValues={initialValues(data)}
        validationSchema={validationSchema}
      >
        {({ handleSubmit }) => (
          <form onSubmit={handleSubmit}>
            <DialogContent>
              <Grid container spacing={3}>
                <Grid item md={12} xs={12}>
                  <Field
                    component={InputText}
                    name="fullname"
                    label="Nama Lengkap"
                    size="small"
                    variant="outlined"
                    type="text"
                    fullWidth
                    multiline
                    maxRows={4}
                  />
                </Grid>
                <Grid item md={12} xs={12}>
                  <Field
                    component={InputText}
                    name="email"
                    label="Email"
                    size="small"
                    variant="outlined"
                    type="email"
                    fullWidth
                  />
                </Grid>
                <Grid item md={12} xs={12}>
                  <Field
                    component={InputText}
                    name="description"
                    label="Keterangan"
                    size="small"
                    variant="outlined"
                    type="text"
                    fullWidth
                    multiline
                    maxRows={4}
                  />
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions>
              <Button
                autoFocus
                onClick={onHide}
                color="error"
                variant="contained"
              >
                Batal
              </Button>
              <LoadingButton
                autoFocus
                loading={isLoading}
                type="submit"
                color="primary"
                variant="contained"
              >
                Simpan
              </LoadingButton>
            </DialogActions>
          </form>
        )}
      </Formik>
    </Dialog>
  );
}
